module.exports = __webpack_public_path__ + "img/9788997889853.b30b63c7.jpg";